export enum NavItemId {
  Guides,
  Home,
  User,
  Company,
  Profile,
  Settings,
  SignOut
}
